import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

export function PageShell({
  className,
  flushBottom,
  children,
}: {
  className?: string;
  flushBottom?: boolean;
  children: ReactNode;
}) {
  return (
    <div data-tone="light" className={cn("min-h-screen", className)}>
      <Header />
      {/* The negative margin keeps the footer under the rounded corners once it
          stops pinning at the end of the page. */}
      <main
        className={cn(
          "relative z-10 -mb-6 rounded-b-3xl bg-inherit",
          !flushBottom && "pb-4 md:pb-16",
        )}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
}
